import { jsx as _jsx } from "react/jsx-runtime";
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { Box, Image, Row, Column } from '@as/cotopaxi';
import { getImageSourceSetByProductCode } from '../../util/ImageUtil';
import { useAemConfig } from '@as-react/common-components';
export const PromoBasketPopupPreview = ({ image, productCode }) => {
    const { productImageConfig } = useAemConfig();
    const imageUrl = getImageSourceSetByProductCode(productCode, image, productImageConfig)[ProductImageSizesPortraitEnum.basket];
    return (_jsx(Row, { clear: true, children: _jsx(Column, { gutter: false, grid: 0, mobile: 5, mobileLarge: 5, tabletSmall: 5, tablet: 12, desktop: 12, children: _jsx(Box, { mobile: { spacing: { marginBottom: 0.5 } }, tablet: { spacing: { marginRight: 2 } }, children: _jsx(Image, { src: imageUrl, alt: productCode, lazy: true }) }) }) }));
};
